import reducer from './module';
import { name, types } from './actionTypes';

export { types, name };
export * from './module';
export default { name, reducer };
